import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments";

@Injectable()
export class PreviewService {
    constructor(private _http: HttpClient) {}

    /**
     * Get a media's preview
     *
     * @param id
     * @param forCropPreview
     * @returns
     */
    getPreview(id: number, forCropPreview : string = 'false'): Observable<any> {
        if (forCropPreview === 'true') {
            let params = new HttpParams().set('forCropPreview', forCropPreview);
            return this._http.get(`${environment.damUrl}/media/${id}/preview.json`, { params: params }).pipe(catchError((_) => of([])));
        }
        return this._http.get(`${environment.damUrl}/media/${id}/preview.json`).pipe(catchError((_) => of([])));
    }

    /**
     * Get all available formats
     */
    getFormats() {
        return this._http.get(`${environment.damUrl}/formats.json`);
    }

    getDownloadFile(id: number, format: string = "HD", extension: string = "", resolution: { width: number; height: number; dpi: number } = null): Observable<any> {
        const body: any = {
            format: format,
            extension: extension,
        };
        // Résolution optionnelle : si fournie, le back redimensionne pour tenir dans
        // la cible (sans upscale, DPI appliqué). Sinon comportement HD/BD inchangé.
        if (resolution) {
            body.resolution = resolution;
        }
        return this._http.post(`${environment.damUrl}/media/${id}/download.json`, body).pipe(catchError((_) => of([])));
    }

    
}
